// Single source of truth for the fixed sidebar width.
// The sidebar (home.js) is position:fixed at SIDEBAR_WIDTH; content areas must
// offset/size by the same value, so keep these derived from one constant.
export const SIDEBAR_WIDTH = 232;
export const SIDEBAR_WIDTH_PX = `${SIDEBAR_WIDTH}px`;
export const CONTENT_WIDTH = `calc(100vw - ${SIDEBAR_WIDTH}px)`;
